import React from 'react';
import OpenNoticeProductItem from '../../../../../containers/app/common/OpenNoticeProductItem';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import Button from '../../../../../components/Button';
import Select from '../../../../../components/input/Select';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import Anchor from '../../../../../components/link/Anchor';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import {
  NOTICE_PRODUCT_STATUS_TEXT,
  NOTICE_PRODUCT_TYPE_SELECT_LIST,
} from '../../../../../constants/service/app/noticeProductConstants';
import {
  addAllItemToSelectList,
  convertTextToShort,
  openNewWindow,
  setColumnWidth,
  setDetailPageUrl,
} from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import { NOTICE_PRODUCT_DETAIL_URL_PATH } from '../../../../../constants/service/common/urlConstants';

/**
 *  상품 공지사항 리스트 컬럼
 */
const columns = (data) => {
  const { list, filterOption, onFilter, deleteNoticeProduct } = data;
  return [
    {
      Header: '상세보기',
      fixed: 'left',
      width: 100,
      Cell: (row) => (
        <Button
          isRadius
          color="primary"
          text="상세보기"
          onClick={() => openNewWindow(setDetailPageUrl(NOTICE_PRODUCT_DETAIL_URL_PATH, row.original.id))}
        />
      ),
    },
    {
      accessor: 'id',
      Header: '상품 공지사항 ID',
      fixed: 'left',
      width: 100,
      Cell: (row) => (
        <Anchor
          isUnderLine
          color="primary"
          text={row.value}
          onClick={() => openNewWindow(setDetailPageUrl(NOTICE_PRODUCT_DETAIL_URL_PATH, row.value))}
        />
      ),
    },
    {
      accessor: 'storeName',
      Header: '브랜드 명',
      fixed: 'left',
      width: setColumnWidth(list, 'storeName'),
      filterable: true,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.storeId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.storeName} onFilter={(storeName) => onFilter({ storeName })} />
      ),
    },
    {
      accessor: 'status',
      Header: '상태',
      filterable: true,
      fixed: 'left',
      width: 120,
      Cell: (row) => NOTICE_PRODUCT_STATUS_TEXT[row.value] || '_',
      Filter: () => (
        <Select
          list={addAllItemToSelectList(NOTICE_PRODUCT_TYPE_SELECT_LIST)}
          onChange={(status) => onFilter({ status })}
          defaultValue={filterOption.status}
          value={filterOption.status}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'title',
      Header: '제목',
      resizable: true,
      filterable: true,
      width: setColumnWidth(list, 'title'),
      Filter: () => <TableFilterInput option={filterOption.title} onFilter={(title) => onFilter({ title })} />,
    },
    {
      accessor: 'content',
      Header: '내용',
      filterable: true,
      width: 340,
      Cell: (row) => (
        <OpenPreviewProductDetail
          text={convertTextToShort(row.value, 30)}
          storeId={row.original.storeId}
          storeName={row.original.storeName}
          noticeContent={row.value}
          productNoticeId={row.original.id}
          disabledActiveValue={true}
        />
      ),
      Filter: () => <TableFilterInput option={filterOption.content} onFilter={(content) => onFilter({ content })} />,
    },
    {
      accessor: 'memo',
      Header: '메모',
      filterable: true,
      width: 300,
      Cell: (row) => convertTextToShort(row.value, 30),
      Filter: () => <TableFilterInput option={filterOption.memo} onFilter={(memo) => onFilter({ memo })} />,
    },
    {
      accessor: 'registeredProductCount',
      Header: '등록된 상품',
      Cell: (row) => <OpenNoticeProductItem productNoticeId={row.original.id} productCount={row.value} />,
    },
    {
      accessor: 'period',
      Header: '노출 기간',
      filterable: true,
      width: 320,
      Filter: () => (
        <DateRangePicker
          value={filterOption.period}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ period: data })}
        />
      ),
    },
    {
      accessor: 'createDate',
      Header: '작성일',
      sortable: true,
      filterable: true,
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.createDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ createDate: data })}
        />
      ),
    },
    {
      Header: '삭제',
      width: 100,
      Cell: (row) => (
        <Button
          isRadius
          color="red"
          text="삭제하기"
          onClick={() => deleteNoticeProduct(row.original.id, row.original.status)}
        />
      ),
    },
  ];
};

export default columns;
